/* @flow */
// typecheck: ignore file
import React from 'react';
import { connect } from 'react-redux';
import type { Ride, RideName, Rides } from 'reducers/joyrides';
import type { RideInformation } from 'constants/rides';
import { AdminSignupRideInformation } from 'constants/rides';
import AdminSignupJoyride from 'app/components/AdminSignupJoyride.jsx';
import eventTracking from 'lib/EventTracking';

import './styles/Joyrides.scss';

type Props = {
  rides: Rides,
};

function rideHasRequiredSteps(rideInformation: RideInformation, ride: Ride) {
  const requiredSteps = [];

  for (const step in rideInformation.steps) {
    if (rideInformation.steps[step].required) {
      requiredSteps.push(step);
    }
  }

  const addedStepsNames = ride.steps.map(step => step.name);
  return requiredSteps.every(requireStep => addedStepsNames.includes(requireStep));
}

/* All visual "tours" should be defined here.
 * To ensure that steps are mounted before the ride starts, every step component adds a step
 * to the reducers/joyride store, once all the required step are added rideHasRequiredSteps
 * will return truen. The last part is JoyrideControlTower that need to gives the goahead to start.
 * Once we have both, we launch!
 */
class Joyrides extends React.Component {
  props: Props;

  callback(rideName: RideName, event: *) {
    if (event.action === 'start') {
      const ride = this.props.rides.get(rideName);
      if (ride && ride.onStart) {
        ride.onStart();
      }
    }

    if (event.type === 'finished') {
      eventTracking.view(rideName, {
        was_skipped: event.isTourSkipped,
        total_steps: event.steps.length,
        steps_names: event.steps.map(step => step.name),
      });
    }
  }

  shouldRunRide(rideInformation: RideInformation) {
    const ride = this.props.rides.get(rideInformation.name);

    return (
      ride &&
      ride.allowedToStart &&
      rideHasRequiredSteps(rideInformation, ride)
    );
  }

  render() {
    const rides = [];
    const shouldRunAdminSignupRide = this.shouldRunRide(AdminSignupRideInformation);

    if (shouldRunAdminSignupRide) {
      const adminSignupRide = this.props.rides.get(AdminSignupRideInformation.name);

      rides.push(
        <AdminSignupJoyride
          key="admin-ride"
          run={shouldRunAdminSignupRide}
          steps={adminSignupRide.steps.toArray()}
          callback={(event) => this.callback(AdminSignupRideInformation.name, event)}
        />
      );
    }

    return <div>{rides}</div>;
  }
}

function mapStateToProps(state: Object) {
  return {
    rides: state.joyrides,
  };
}

export { Joyrides };
export default connect(mapStateToProps, undefined)(Joyrides);



// WEBPACK FOOTER //
// ./src/app/components/Joyrides.jsx